export const FAILED_ADDRESS_VALIDATION = 'failed_address_validation';
